
import AppLayout from "core/layouts/AppLayout";
import PageHeader from "core/components/Header/PageHeader";
import { useCustomNavigate } from "core/hooks/useCustomNavigate";
import { _t } from "core/language";
import LanguageListItem, { LanguageListItemProps } from "core/components/LanguageListItem";
import LangKo from 'core/assets/icons/lang/lang_ko.svg';
import LangEn from 'core/assets/icons/lang/lang_usa.svg';
import LangVi from 'core/assets/icons/lang/lang_vi.svg';
import LangTh from 'core/assets/icons/lang/lang_th.svg';
import LangMy from 'core/assets/icons/lang/lang_my.svg';
import LangId from 'core/assets/icons/lang/lang_id.svg';
import LangJa from 'core/assets/icons/lang/lang_ja.svg';
import LangZh from 'core/assets/icons/lang/lang_zh.svg';
import LangDe from 'core/assets/icons/lang/lang_de.svg';
import LangFr from 'core/assets/icons/lang/lang_fr.svg';
import LangHi from 'core/assets/icons/lang/lang_in.svg';
import { useEffect, useState } from "react";
import { Button } from "core/components/form-controls";
import BottomNavigation from "core/layouts/BottomNavigation";

import { useAppSetting } from "modules/AppSettings/hooks";
import API, { settingApplication, setupAxios } from "core/networks/API";
import { API_LANGUAGE_UPDATE } from "../api";
import { useRecipe } from "modules/Ingredients/hooks/recipe";
import { route, RouterName } from '../../../core/router';
import { useSelector } from "react-redux";

const LanguageSetting = () => {
  const { resetRecipes } = useRecipe()
  const navigate = useCustomNavigate();
  const appSetting = useAppSetting();
  const langCurrent = (window as any)._APP_LANG
  const auth = useSelector((state: any) => state.Auth);

  const mapFlagIconLanguage = (lang: string) => {
    let flagIcon = ''
    switch (lang) {
      case 'ko':
        flagIcon = LangKo
        break;
      case 'en':
        flagIcon = LangEn
        break
      case 'th':
        flagIcon = LangTh
        break
      case 'my':
        flagIcon = LangMy
        break
      case 'id':
        flagIcon = LangId
        break
      case 'zh':
        flagIcon = LangZh
        break
      case 'ja':
        flagIcon = LangJa
        break
        case 'hi':
        flagIcon = LangHi
        break
        case 'fr':
        flagIcon = LangFr
        break
        case 'de':
        flagIcon = LangDe
        break
      default:
        flagIcon = LangVi
        break
    }
    return flagIcon
  }

  const [languages, setLanguages] = useState<LanguageListItemProps[]>([]);
  const [langChoose, setLangChoose] = useState({ code: '', id: '' });

  useEffect(() => {
    const listLang: LanguageListItemProps[] = []
    if (appSetting?.languages?.length > 0) {
      appSetting.languages.forEach((item: any) => {
        listLang.push({
          selected: item.code === langCurrent,
          name: item.name || '',
          code: item.code || '',
          id: item.id || '',
          flagIcon: item?.flag_icon ? item?.flag_icon : mapFlagIconLanguage(item.code)
        });
        if(item.code === langCurrent) {
          setLangChoose({ code: item.code, id: item.id })
        }
      });

    }
    setLanguages(listLang)
  }, [appSetting?.languages, langCurrent])

  const handleGoBack = () => {
    navigate(route(RouterName.MENU))
  }


  const handleSubmitChangeLang = async () => {
    const dataRequest = {
      lang_id: langChoose?.id,
    }

    // when user not login
    if(!auth?.token) {
      (window as any)._APP_LANG = langChoose.code;
        settingApplication()
        setupAxios()
        // @ts-ignore
        window.webviewResponeLanguage({ lang: langChoose.code });
        setLangChoose({ code: '', id: '' })
        setTimeout(() => {
          handleGoBack()
        }, 450);
        return
    }

    //when user login
    try {
      const { data: response } = await API.post(`${API_LANGUAGE_UPDATE}`, dataRequest)
      if (response && response?.code === 200) {
        (window as any)._APP_LANG = langChoose.code;
        settingApplication()
        setupAxios()
        // @ts-ignore
        window.webviewResponeLanguage({ lang: langChoose.code });
        setLangChoose({ code: '', id: '' })
        setTimeout(() => {
          handleGoBack()
        }, 450);
      }
    } catch (e: any) {
      console.log('error', e);
      
    }
  }


  const handleSelectLang = (data: string) => {

    const listLangMap = languages.map((item: any) => {
      item.selected = item.code === data ? true : false
      if (item.code === data) {
        setLangChoose({ code: item.code, id: item.id })
      }
      return item
    })
    setLanguages(listLangMap)
  }


  return (
    <AppLayout>
      <PageHeader sticky title={_t('auth.LanguageSetting')} handleGoBack={handleGoBack} />
      <div className="flex flex-col px-4 py-[50px] w-full">
        <div className="grid grid-cols-2 gap-x-2.5">
          {languages.length > 0 && languages.map((lang: any, index: number) => (
            <LanguageListItem
              handleClick={handleSelectLang}
              key={index}
              {...lang}
            />
          ))}
        </div>
        <div className="absolute left-0 bottom-[60px] w-full px-4">
          <Button disabled={langChoose?.code === langCurrent ? true : false} onClickBtn={handleSubmitChangeLang} size="lg" label={_t('auth.Confirm')} classBtn="w-full mb-[50px] font-medium" />
        </div>
      </div >
      <BottomNavigation onNavigateChange={resetRecipes} activeIndex={5} />
    </AppLayout >
  );
};

export default LanguageSetting;
